export class ReplaySyncPoint {
  public frame: number = 0;
  public positions: Array<any> = new Array();
  public angles: Array<any> = new Array();
  public cannonballPositions: Array<any> = new Array();
}
